// extracted by mini-css-extract-plugin
export default {"form-container":"RenderForm_form-container__mA8tW"};